import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) {
  throw new Error(
    'VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set (see .env.example)',
  );
}

export const supabaseClient = createClient(url, key, {
  db: { schema: 'public' },
  auth: { persistSession: true, storageKey: 'admin-refine.auth' },
});
